import customFetch from '../customFetch';

const API_URL = process.env.VUE_APP_MACHETE_AUTH_API;

const VERIFY_PASSWORD_RECOVERY_URL = `${API_URL}/verify-token/password-recovery`;
const EMAIL_VERIFY_URL = `${API_URL}/verify-token/email/resend`;
const FORGOTTEN_PASSWORD_URL = `${API_URL}/forgotten-password`;
const PASSWORD_RECOVERY_URL = `${API_URL}/password-recovery`;
const VERIFY_EMAIL_URL = `${API_URL}/verify-token/email`;
const SIGN_UP_WITH_COMPANY_URL = `${API_URL}/sign-up/with-company`;
const SESSION_URL = `${API_URL}/validate/session`;
const SIGN_IN_URL = `${API_URL}/sign-in`;
const SIGN_UP_URL = `${API_URL}/sign-up`;
const ADD_RFC_URL = `${API_URL}/add-rfc`;
const VALIDATE_CONFIRMATION_CODE = `${API_URL}/validate/confirmation-code/:externalId`;

export default {
  async validateSession() {
    const token = sessionStorage.getItem('access_token')
      || localStorage.getItem('access_token');

    if (!token) throw new Error('user don\'t sign in');

    try {
      const response = await customFetch(SESSION_URL);
      const { payload } = await response.json();
      return payload;
    } catch (error) {
      sessionStorage.removeItem('access_token');
      localStorage.removeItem('access_token');
      throw error;
    }
  },

  async resendEmailVerification() {
    const response = await customFetch(EMAIL_VERIFY_URL);

    const { payload } = await response.json();

    return payload;
  },

  async signIn(email, password) {
    const response = await customFetch(SIGN_IN_URL, {
      method: 'POST',
      body: JSON.stringify({ email, password }),
      errors: [
        { code: 404, message: 'El email proporcionado no existe' },
        { code: 422, message: 'Contraseña incorrecta' },
      ],
    });

    const { payload } = await response.json();
    return payload;
  },

  async signUp(data) {
    const query = new URLSearchParams(window.location.search);

    const response = await customFetch(SIGN_UP_URL, {
      method: 'POST',
      body: JSON.stringify({
        ...data,
        from: query.get('from') || '',
        campaign: query.get('campaign') || '',
      }),
    });

    const { payload } = await response.json();

    return payload;
  },

  async signUpWithCompany(data) {
    const query = new URLSearchParams(window.location.search);

    const response = await customFetch(SIGN_UP_WITH_COMPANY_URL, {
      method: 'POST',
      body: JSON.stringify({
        ...data,
        from: data.from || query.get('from') || '',
        campaign: data.campaign || query.get('campaign') || '',
        externalId: query.get('confirmationId') || '',
      }),
    });

    const { payload } = await response.json();

    return payload;
  },

  async addRFC(rfc, name) {
    const response = await customFetch(ADD_RFC_URL, {
      method: 'POST',
      body: JSON.stringify({ rfc, name }),
      errors: [
        { code: 412, message: 'RFC ya existe' },
      ],
    });

    const { payload } = await response.json();

    return payload;
  },

  async passwordRecovery(password, token) {
    const response = await customFetch(PASSWORD_RECOVERY_URL, {
      method: 'POST',
      body: JSON.stringify({ password, token }),
    });

    const { payload } = await response.json();
    return payload;
  },
  async verifyEmail(token) {
    const response = await customFetch(VERIFY_EMAIL_URL, { query: { token } });

    const { payload } = await response.json();

    return payload;
  },
  async verifyPasswordRecovery(token) {
    const response = await customFetch(
      VERIFY_PASSWORD_RECOVERY_URL,
      { query: { token } },
    );

    const { payload } = await response.json();
    return payload;
  },
  async forgottenPassword(email) {
    const response = await customFetch(FORGOTTEN_PASSWORD_URL, {
      method: 'POST',
      body: JSON.stringify({ email }),
      errors: [
        { code: 404, message: 'El email proporcionado no existe' },
      ],
    });

    const { payload } = await response.json();
    return payload;
  },

  async verifyConfirmationCode() {
    const query = new URLSearchParams(window.location.search);

    const response = await customFetch(VALIDATE_CONFIRMATION_CODE, {
      method: 'GET',
      params: { externalId: query.get('confirmationId') || '' },
    });

    const { payload } = await response.json();

    return payload;
  },
};
